import React from 'react';
import { connect } from 'react-redux';

import { LOADER_NAMESPACE } from 'src/constants/forms';
import { setHideLoader, setShowLoader } from 'src/core/redux/actions';
import { selectLoaderData } from 'src/core/redux/selectors';

export default (WrappedComponent) => {
  const Component = (props) => <WrappedComponent {...props} />;

  const mapStateToProps = (state) => ({
    isLoaderVisible: selectLoaderData(state)
  });

  const mapDispatchToProps = (dispatch) => ({
    showLoader: () => dispatch(setShowLoader(LOADER_NAMESPACE, '')),
    hideLoader: () => dispatch(setHideLoader(LOADER_NAMESPACE, ''))
  });

  return connect(mapStateToProps, mapDispatchToProps)(Component);
};
